import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // メインビジュアルスライド
  document.addEventListener('DOMContentLoaded', () => {
    const fadeSlider = new Swiper('.js-fade-slider', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true, // フェードをクロスさせる（自然に切替）
      },

      speed: 1000, // フェードに1秒
      autoplay: {
        delay: 10000, // 12秒ごとに切替
        disableOnInteraction: false,
      },

      loop: true,
      allowTouchMove: false, // スワイプ操作をさせないなら true
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })

    const slider = new Swiper('.js-topInterview-slider', {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      speed: 600,
      spaceBetween: 0,

      navigation: {
        nextEl: '.topInterview__next',
        prevEl: '.topInterview__prev',
      },

      on: {
        init(swiper) {
          updateFraction(swiper)
          setActiveInterviewContent(swiper.realIndex)
        },
        slideChangeTransitionEnd(swiper) {
          updateFraction(swiper)
          setActiveInterviewContent(swiper.realIndex)
        },
      },
    })

    function updateFraction(swiper) {
      const realIndex = swiper.realIndex
      const contentBoxes = document.querySelectorAll('.topInterview__contentBox')
      const total = contentBoxes.length
      const current = total > 0 ? (realIndex % total) + 1 : 1

      const currentEl = document.querySelector('.topInterview__fraction .current')
      const totalEl = document.querySelector('.topInterview__fraction .total')

      if (currentEl && totalEl) {
        currentEl.textContent = String(current).padStart(2, '0')
        totalEl.textContent = String(total).padStart(2, '0')
      }
    }

    function setActiveInterviewContent(realIndex) {
      const contentBoxes = document.querySelectorAll('.topInterview__contentBox')
      const total = contentBoxes.length
      if (total === 0) return
      const index = realIndex % total
      const activeNum = String(index + 1).padStart(2, '0')
      contentBoxes.forEach((box) => {
        box.classList.toggle('is-active', box.classList.contains(`topInterview__contentBox--${activeNum}`))
      })
    }
  })

window.addEventListener('load', () => {
  const dot = document.querySelector('.topMvScroll__dot');
  const line = document.querySelector('.topMvScroll__line');

  const duration = 3000;

  let maxMove = 0;

  function updateSize() {
    const lineHeight = line.clientHeight;
    const dotHeight = dot.clientHeight;
    maxMove = lineHeight - dotHeight;
  }

  // 初回計算
  updateSize();

  // リサイズ時に再計算
  window.addEventListener('resize', updateSize);

  function animate(time) {
    const progress = (time % duration) / duration;
    const position = maxMove * progress;

    dot.style.top = position + 'px';

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
});

}
